import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { userRoleMapper } from '../Users';
import { get } from 'lodash';
import './ListItem.scss';

export default class ListItem extends Component {
    static propTypes = {
        item: PropTypes.any.isRequired,
        onGoToItem: PropTypes.func
    };

    static defaultProps = {
        item: {}
    };

    renderNames() {
        const item = this.props.item;

        if (item.firstName || item.lastName) {
            return <div className="names">
                <div className="full-name">
                    {`${item.firstName} ${item.lastName}`}
                </div>
                <div className="user-name">
                    {item.userName}
                </div>
            </div>;
        } else {
            return <div className="names">
                <div className="full-name">
                    {item.userName}
                </div>
            </div>;
        }
    }

    render() {
        return (<div className="users-list-item" onClick={this.props.onGoToItem}>
            <div className="names-and-role">
                {this.renderNames()}
                <div className="role">
                    {userRoleMapper[get(this.props.item, 'accessRights.role')]}
                </div>
            </div>
        </div>);
    }
}
